import type { TrackData } from '../types';

export interface TrackService {
    trackAir(data: TrackData): Promise<boolean>;
    trackSeek(data: TrackData): Promise<boolean>;
}

export const TrackService = Symbol('TrackService');
